import React from 'react'
import { Link } from "react-router-dom"
import { NavHashLink as Navlink } from "react-router-hash-link"
import styled from "styled-components"
import media from "styled-media-query"

import logoImg from "../image/logo.png"

const Footer = () => {
   return (
      <FooterStyles>
         <div className="wrap">
            <div className="box">
               <div className="footer-left">
                  <img src={logoImg} alt="logo"/>
                  <p>
                     〒208-0013<br/>
                     東京都武蔵村山市大南４丁目１８−１
                  </p>
               </div>
               <div className="footer-right">
                  <nav>
                     <ul>
                        <Link to="/">
                           <li>TOP</li>
                        </Link>
                        <Link to="/introduce">
                           <li>塾の紹介</li>
                        </Link>
                        <Link to="/courses">
                           <li>コース</li>
                        </Link>
                        <Link to="/records">
                           <li>合格実績</li>
                        </Link>
                        <Navlink smooth to="/#access">
                           <li>アクセス</li>
                        </Navlink>
                        <Navlink smooth to="/#contact">
                           <li>お問い合わせ</li>
                        </Navlink>
                     </ul>
                  </nav>
               </div>
            </div>
            <p className="copy-right">© 2020 天心塾 All rights reserved.</p>
         </div>
      </FooterStyles>
   )
}

const FooterStyles = styled.footer`
   width: 100%;
   background-color: #5E5E5E;
   .wrap {
      width: 85%;
      margin: 0 auto;
      padding-top: 90px;
      .box {
         display: flex;
         justify-content: space-between;
      }
   }
   .footer-left {
      color: #fff;
      img {
         height: 45px;
      }
      p {
         font-size: 2.2rem;
         margin-top: 30px;
         line-height: 3.2rem;
         ${media.lessThan("960px")`
            font-size: 1.4rem;
         `}
      }
   }
   .footer-right {
      ${media.lessThan("960px")`
         display: none;
      `}
      nav {
         margin-top: 75px;
         ul {
            li {
               color: #fff;
               font-size: 2.2rem;
               margin-top: 10px;
               &:hover {
                  text-decoration: underline;
               }
            }
         }
      }
   }
   .copy-right {
      height: 80px;
      margin-top: 50px;
      font-size: 1.3rem;
      line-height: 80px;
      text-align: center;
      color: #D3D3D3;
      border-top: 1px solid #D3D3D3;
   }
`

export default Footer